module.exports = __webpack_public_path__ + "28004f6ece1704b54bdae9d3daa1c8db.svg";